export const getVatNumberEditModalSelector = ({ billing }) => billing.editBillingModal.values.vatNumber;
